export default __webpack_public_path__ + "static/media/contained1_left.4c319b0e.svg";